import { Injectable } from "@angular/core";
import { AuthModule } from '../auth.module';

@Injectable({
  providedIn: AuthModule
})
export class CodeChallengeStorageService {
  storageKey = "code_challenge";

  constructor() {}

  loadCodeChallenge() {
    return localStorage.getItem(this.storageKey);
  }

  storeCodeChallenge(codeChallenge) {
    localStorage.setItem(this.storageKey, codeChallenge);
  }

  clear() {
    localStorage.removeItem(this.storageKey);
  }
}
